// adapter.ts

interface AdapterElements {
  url: string;
  type: string;
  data?: unknown;
  headers?: Record<string, string>;
}

interface AdapterError extends Error {
  status?: number;
  data?: any;
}

export default function CustomFetchAdapter(elements: AdapterElements) {
  const { url, type, data, headers } = elements;
  const controller = new AbortController();

  const fetchPromise = fetch(url, {
    method: type,
    body:
      data instanceof FormData || data instanceof URLSearchParams
        ? data
        : data
        ? JSON.stringify(data)
        : undefined,
    headers: {
      ...(headers || {}),
      ...(data && !(data instanceof FormData)
        ? { "Content-Type": "application/json" }
        : {}),
    },
    signal: controller.signal,
  });

  return {
    async response(): Promise<any> {
      const response = await fetchPromise;

      if (!response.ok) {
        const errorData = await response.json().catch(() => null);

        const error: AdapterError = new Error(
          errorData?.message || `HTTP error! status: ${response.status}`
        );

        error.status = response.status;
        error.data = errorData;

        throw error;
      }

      const result = await response.json();
      return { ...result, status: response.status };
    },

    async headers(): Promise<Headers> {
      return (await fetchPromise).headers;
    },

    abort(): void {
      controller.abort();
    },
  };
}
